export const environment = {
  production: false,
  hmr: true,
  tokenKey: "a6smm_utoken",
  // wssocket_url: 'wss://websocket-visualizer.hansel.io',
  // wssocket_url: 'wss://diltest.hansel.io',
  wssocket_url: 'wss://staging-websocket.hansel.io',
  returnURL: 'https://diltest.hansel.io/redirecting-to-netcore-ce',
  // wssocket_url: 'wss://websocket-visualizer.hansel.io',
  setToken: function (token) {
    localStorage.setItem(this.tokenKey, JSON.stringify(token));
  },
  isAuthenticated: function () {
    let isTokenAvailable = localStorage.getItem(this.tokenKey) ? true : false;
    return isTokenAvailable;
  },
  refreshToken() {
    this.token.exp = new Date(new Date().getDate() + 1);
    this.setToken(this.token);
  }
};